import React from 'react';
import { Grid, Box, useTheme, useMediaQuery } from '@mui/material';

const DashboardGrid = ({ children, spacing = 3 }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <Box sx={{ 
      width: '100%',
      px: { xs: 1, sm: 2, md: 3 },
      py: { xs: 2, sm: 3 }
    }}>
      <Grid 
        container 
        spacing={{ xs: 2, sm: spacing, md: spacing }}
        sx={{
          // מבטיח שכל הקארדים באותו גובה
          '& .MuiGrid-item': {
            display: 'flex',
            '& > *': {
              width: '100%'
            }
          }
        }}
      >
        {children}
      </Grid>
    </Box>
  );
};

// קומפוננט עוטף לקארדי KPI
export const KPISection = ({ children }) => (
  <DashboardGrid spacing={3}>
    {React.Children.map(children, (child, index) => (
      <Grid item xs={12} sm={6} md={3} key={index}>
        {child}
      </Grid>
    ))}
  </DashboardGrid>
);

// קומפוננט עוטף לתרשימים
export const ChartsSection = ({ children }) => (
  <DashboardGrid spacing={4}>
    {React.Children.map(children, (child, index) => {
      // תרשימים יכולים להיות בגדלים שונים
      const defaultProps = {
        xs: 12,
        md: 6,
        lg: child.props?.fullWidth ? 12 : 6
      };
      
      return (
        <Grid item {...defaultProps} {...child.props?.gridProps} key={index}>
          {child}
        </Grid>
      );
    })}
  </DashboardGrid>
);

// קומפוננט עוטף לטבלאות ורשימות
export const DataSection = ({ children, columns = 1 }) => {
  const getColumnLayout = () => {
    switch (columns) {
      case 1:
        return { xs: 12 };
      case 2:
        return { xs: 12, lg: 6 };
      case 3:
        return { xs: 12, md: 6, lg: 4 };
      default:
        return { xs: 12, sm: 6, md: 4, lg: 3 };
    }
  };

  return (
    <DashboardGrid spacing={3}>
      {React.Children.map(children, (child, index) => (
        <Grid item {...getColumnLayout()} key={index}>
          {child}
        </Grid>
      ))}
    </DashboardGrid>
  );
};

export default DashboardGrid;
